import { render, staticRenderFns } from "./header-logo.vue?vue&type=template&id=79628f56&"
import script from "./header-logo.vue?vue&type=script&lang=js&"
export * from "./header-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TritonPresentation\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79628f56')) {
      api.createRecord('79628f56', component.options)
    } else {
      api.reload('79628f56', component.options)
    }
    module.hot.accept("./header-logo.vue?vue&type=template&id=79628f56&", function () {
      api.rerender('79628f56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Scripts/app/components/header-bar/header-logo.vue"
export default component.exports